import type { AxiosError } from 'axios';
import axios from 'axios';

export const isAxiosError = (value: unknown): value is AxiosError => axios.isAxiosError(value);
